import cx from 'classnames';
import {Button} from './Button';
import {Typography} from './Typography';

export const Pill = ({
  'data-qa-id': dataQaId,
  id = dataQaId,
  onClick,
  title,
  startAdornment = null,
  endAdornment = null,
  disabled = false,
  className = null,
}) => (
  <Button
    variant="unstyled-button"
    className={cx('pill', className)}
    onClick={onClick}
    data-qa-id={dataQaId}
    id={id}
    disabled={disabled}
    disableProcessing
  >
    {startAdornment}
    <Typography variant="paragraph3" as="span">
      {title}
    </Typography>
    {endAdornment}
  </Button>
);
